import { useContext } from 'react'
import { MySettingsContext } from '../MySettingsProvider';

export const useTheme = () => {
  const { theme } = useContext(MySettingsContext);
  return {
    currentTheme: theme.current,
    setCurrentTheme: theme.set
  }
}
